import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import GroupFormFields from "./GroupFormFields.js";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.grupos.edit}
                postUrl={api.usuarios.grupos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Grupo ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                buttonTitle={"Editar Grupo"}
                title={"Editar Grupo"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <GroupFormFields />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Grupos/Edit.js